// the following info is indicated on each contract, in "_info" field

export const SmartContractVersion = {
  EWC: "EWC", //Smart contract deployed on EWC
  V3: "SMART CONTRACT V3", //also smart contract deployed on EWC
  VOLTA: "Volta", //Smart contract deployed on Volta
  TOBALABA: "SMART CONTRACT V2" //Smart contract deployed on Tobalaba 
}



// WEBPACK FOOTER //
// ./src/enums/SmartContractVersion.js